module.exports = __webpack_public_path__ + "img/Monte_Kope_50.5b54d843.jpg";